import React from "react";
import get from "lodash/get";
import { object, bool, string, number, array } from "prop-types";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";
import { getAuthorName } from "../../utils/utils";

import "./authorDetails.m.css";

const AuthorDetails = ({
  story = {},
  authors = [],
  authorDisplayName = "",
  withAvatar = true,
  contributorType = 4,
  role = "",
  authorDetailsType = "",
  lang = "en",
  location = true,
}) => {
  const authorName = getAuthorName(story);
  const authorLocation = get(story, ["metadata", "author-location"], "");
  const slug = authors[0] ? `/author/${authors[0].slug}` : "";

  return (
    <div styleName="base">
      <div className="author-details" styleName={authorDetailsType}>
        {withAvatar && !authorDisplayName && <ContributorImage authorObj={authors[0]} slug={slug} />}
        {withAvatar && authorDisplayName && (
          <ContributorImage authorDisplayName={authorDisplayName} authorObj={authors[0]} slug={slug} />
        )}
        <div className="author-name-location-wrapper">
          <div styleName="authors-list" className="print-authors-list">
            {!authorDisplayName && authors.length > 0 ? (
              authors.map((item, index) => (
                <Contributor
                  key={index}
                  name={item.name}
                  role={role}
                  contributorType={contributorType}
                  slug={`/author/${item.slug}`}
                  authorObj={item}
                />
              ))
            ) : (
              <Contributor
                name={authorName}
                role={role}
                contributorType={contributorType}
                slug={slug}
                authorObj={authors[0] || {}}
                authorDisplayName={authorDisplayName}
              />
            )}
          </div>
          {location && <span styleName={`author-location ${lang}-author-location`}>{authorLocation}</span>}
        </div>
      </div>
    </div>
  );
};

AuthorDetails.propTypes = {
  story: object,
  authors: array,
  withAvatar: bool,
  contributorType: number,
  role: string,
  authorDisplayName: string,
  authorDetailsType: string,
  lang: string,
  location: bool,
};

export default AuthorDetails;
